<template>
  <div class="tt-host">
    <div class="m-wrap">
      <div class="m-hero">
        <img class="m-bg" :src="bgSrc" alt="" />

        <div class="m-title">
          <div class="m-title__line1">{{ $t('Tabletop Game Guide') }}</div>
          <div class="m-title__line2">{{ $t("RULE: DON'T FALL OFF!") }}</div>
        </div>

        <!-- Cards overlay area (like your screenshot) -->
        <div class="m-cards">
          <div class="m-card m-card--left">
            <img class="m-hex" :src="cardFightSrc" alt="" />
            <div class="m-desc">{{ $t('Roosters fight on the table top arena.') }}</div>
          </div>

          <div class="m-card m-card--right">
            <div class="m-desc">{{ $t('First rooster to touch the floor LOSES.') }}</div>
            <img class="m-hex" :src="cardLoseSrc" alt="" />
          </div>

          <div class="m-card m-card--left">
            <img class="m-hex" :src="cardWinSrc" alt="" />
            <div class="m-desc">{{ $t('Rooster remaining on the table WINS.') }}</div>
          </div>

          <div class="m-card m-card--right">
            <div class="m-desc">{{ $t('Draw when both rooster fall off at the same time') }}</div>
            <img class="m-hex" :src="cardDrawSrc" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'TabletopRules',
        data() {
            return {
                bgSrc: require('@/assets/images/game-help/table-bg-mobile.webp'),

                cardFightSrc: require('@/assets/images/game-help/tgg-1.webp'),
                cardLoseSrc: require('@/assets/images/game-help/tgg-2.webp'),
                cardWinSrc: require('@/assets/images/game-help/tgg-3.webp'),
                cardDrawSrc: require('@/assets/images/game-help/tgg-4.webp'),

            };
        },
    };
</script>

<style lang="scss" scoped>
    /* Self-contained sizing: no parent changes needed */
    .tt-host {
        width: 100%;
        position: relative;
        overflow: visible;
    }

    .m-wrap {
        width: 100%;
        box-sizing: border-box;
        color: #efddb5;
    }

    /* Hero area */
    .m-hero {
        position: relative;
        width: 100%;
        overflow: hidden;
        aspect-ratio: 215 / 294;
        container-type: inline-size;
    }

    .m-bg {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    /* Title overlay */
    .m-title {
        position: absolute;
        top: 5%;
        left: 0;
        right: 0;
        text-align: center;
        text-transform: uppercase;
        text-shadow: 0 6px 18px rgba(0, 0, 0, 0.7);
    }

    .m-title__line1 {
        font-weight: 900;
        letter-spacing: 0.06em;
        font-size: 5.8cqw;
        color: #f2c36b;
        line-height: 1.1;
    }

    .m-title__line2 {
        margin-top: 10px;
        font-weight: 900;
        letter-spacing: 0.12em;
        font-size: 3.4cqw;
        color: #efddb5;
        line-height: 1.1;
    }

    /* Cards overlay zone (absolute like your screenshot) */
    .m-cards {
        position: absolute;
        left: 0;
        right: 0;
        top: 22%;
        padding: 0 12px 14px;
        display: grid;
        grid-template-columns: 1fr;
    }

    /* Each row is a 2-column mini layout */
    .m-card {
        display: grid;
        grid-template-columns: 30cqw 1fr;
        align-items: center;
        gap: 10px;
    }

    .m-card--left {
        .m-desc{
            padding-right: 5cqw;
        }
    }

    .m-card--right {
        grid-template-columns: 1fr 30cqw;
        .m-desc{
            padding-left: 5cqw;
        }
    }

    .m-hex {
        width: 30cqw !important;
        height: auto !important;
        filter: drop-shadow(0 12px 20px rgba(0, 0, 0, 0.55));
    }

    .m-desc {
        font-size: 3.4cqw;
        font-weight: 400;
        line-height: 1.25;
        color: #efddb5;
        text-shadow: 0 4px 14px rgba(0, 0, 0, 0.75);
    }

    .m-card--right .m-desc {
        text-align: right;
    }

</style>